exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".icon-download[data-v-2d46b853]{position:relative;display:flex;flex-direction:row;align-items:center;margin-right:40px;margin-bottom:15px}.icon-download img[data-v-2d46b853]{display:block;width:20px;margin-right:10px;align-self:flex-start}.icon-download a[data-v-2d46b853]{display:block;text-decoration:none}@media screen and (max-width:900px){.icon-download a[data-v-2d46b853]{white-space:nowrap}}.icon-download a p[data-v-2d46b853]{font-size:14px;line-height:30px;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d46b853","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/IconDownload.vue
// module id = 352
// module chunks = 0